module.exports = __webpack_public_path__ + "img/tm.dff619d7.svg";